module.exports = __webpack_public_path__ + "static/media/tankshot.308f758c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/samples/tankshot.mp3
// module id = 31
// module chunks = 0